module.exports = __webpack_public_path__ + "static/img/manufactur-industry-h5-4.71891fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/manufactur-industry-h5-4.png
// module id = 3smq
// module chunks = 34